import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearUser: (state) => {
      state.userData = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setUserData,
  setLoading,
  setError,
  clearUser,
} = userSlice.actions;

export default userSlice.reducer; 